<div class="container">
  <div class="col-md-12 mb-5 empl-tptxt">
    <h3>Data Repository</h3>
  </div>

  <form>
    <div class="col-12">
      <div class="row">
        <div class="col-md-12 mt-5 d-flex justify-content-center empl-tptxt">
          <h3>What are you looking for?</h3>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center">
          <div class="mb-3 col-md-3">
            <div class="search-container d-flex justify-content-center">
              <input type="text" class="form-control" />
              <i class="fa fa-search"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-category-selector [module]="'NA'" (categorySelectorEvent)="onCategorySelected($event)"></app-category-selector>
  </form>
  <br />
  <div class="row">
    <div class="col-12 d-flex mt-4 justify-content-center acvtypglastbtn">
      <a><button type="button" class="btn" (click)="navigateToQuickSelectPage()">NEXT</button></a>
      <a><button type="button" class="btn-discard" (click)="exit()">EXIT</button></a>
    </div>
  </div>
</div>
